import { gql } from '@apollo/client';

export const GET_HOTEL_THEME_QUERY = gql`
  query GetHotelTheme($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      theme {
        id
        primary
        secondary
        tertiary
        success
        warning
        danger
        dark
        medium
        light
        actionPrimary
        actionSecondary
      }
    }
  }
`;
